import { apiFetch, apiFetchEnvelope, type ListMeta } from "@core/http";
import type { operations, components } from "@core/types/openapi";

type HttpRequestLogQuery = NonNullable<
  operations["portalQueryHttpRequestLog"]["parameters"]["query"]
>;
type HttpRequestLogResponse = NonNullable<
  operations["portalQueryHttpRequestLog"]["responses"][200]["content"]["application/json"]
>;

export type HttpRequestLogFilters = Pick<
  HttpRequestLogQuery,
  | "correlationId"
  | "method"
  | "pathContains"
  | "surface"
  | "status"
  | "onlyErrors"
  | "hasException"
  | "actorId"
  | "from"
  | "to"
>;

export type HttpRequestLogSummary =
  components["schemas"]["HttpRequestLogSummary"];
export type HttpRequestLogDetail =
  components["schemas"]["HttpRequestLogDetail"];

export type HttpRequestLogPage = {
  items: HttpRequestLogSummary[];
  meta: ListMeta;
};

// Solo lo que trae valor: `undefined` y cadenas vacías no viajan (mismo
// criterio que `queryAccessLog`). Los booleanos declarados (`onlyErrors`,
// `hasException`) sí viajan aunque sean `false`, porque `false` es una
// elección explícita del filtro, no "sin filtrar".
function toParams(
  filters: HttpRequestLogFilters,
  cursor: string | undefined,
): URLSearchParams {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries({ ...filters, cursor })) {
    if (value === undefined || value === "") continue;
    params.set(key, String(value));
  }
  return params;
}

export async function queryHttpRequestLog(
  filters: HttpRequestLogFilters,
  cursor?: string,
): Promise<HttpRequestLogPage> {
  const suffix = toParams(filters, cursor).toString();
  const envelope = await apiFetchEnvelope<
    NonNullable<HttpRequestLogResponse["data"]>
  >(`/v1/portal/security/http-request-log${suffix ? `?${suffix}` : ""}`);
  return {
    items: envelope.data.items,
    meta: envelope.meta ?? { next: null, total: envelope.data.items.length },
  };
}

export async function getHttpRequestLog(
  id: string,
): Promise<HttpRequestLogDetail> {
  return apiFetch<HttpRequestLogDetail>(
    `/v1/portal/security/http-request-log/${encodeURIComponent(id)}`,
  );
}
